var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14858_3100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.20001,
    y: 6,
    width: 10.8,
    height: 10.8,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 1.99994C17.5222 1.99994 21.9992 6.47694 21.9992 11.9999C21.9992 17.5229 17.5222 21.9999 11.9992 21.9999C6.47621 21.9999 1.99921 17.5229 1.99921 11.9999C1.99921 6.47694 6.47621 1.99994 11.9992 1.99994ZM9.87821 8.46394C9.69867 8.28268 9.45664 8.17691 9.20166 8.16826C8.94668 8.15961 8.69804 8.24874 8.50663 8.4174C8.31521 8.58607 8.1955 8.82152 8.172 9.07556C8.1485 9.3296 8.22298 9.58302 8.38021 9.78394L8.46421 9.87894L10.5842 11.9989L8.46421 14.1209C8.28295 14.3005 8.17717 14.5425 8.16852 14.7975C8.15987 15.0525 8.249 15.3011 8.41767 15.4925C8.58634 15.6839 8.82179 15.8036 9.07583 15.8271C9.32987 15.8506 9.58329 15.7762 9.78421 15.6189L9.87821 15.5359L11.9992 13.4139L14.1202 15.5359C14.2997 15.7172 14.5418 15.823 14.7968 15.8316C15.0517 15.8403 15.3004 15.7511 15.4918 15.5825C15.6832 15.4138 15.8029 15.1784 15.8264 14.9243C15.8499 14.6703 15.7754 14.4169 15.6182 14.2159L15.5352 14.1209L13.4132 11.9999L15.5352 9.87894C15.7165 9.6994 15.8222 9.45737 15.8309 9.20239C15.8395 8.94741 15.7504 8.69877 15.5817 8.50736C15.4131 8.31595 15.1776 8.19624 14.9236 8.17274C14.6695 8.14923 14.4161 8.22372 14.2152 8.38094L14.1202 8.46394L11.9992 10.5859L9.87821 8.46394Z",
    fill: "#FF3131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14858_3100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4ca2d83996b3a75269e031bf0ee90835.svg";
export { ForwardRef as ReactComponent };